import { FavoriteType } from "__generated__/graphql";
import { Favorite } from "types/commons";
import { Relation } from "types/index";
import { relationTypesAndBooleans } from "utils/relationUtils";

export const getFavorites = (favorites: Favorite[], entityType: FavoriteType) => {
	return favorites.filter((it) => it.entityType === entityType);
};

export const getLocationFavorites = (favorites: Favorite[], types?: Array<string>) => {
	return favorites
		.filter((it) => it.entityType === FavoriteType.Location)
		.filter((it) => types ? types.includes(it.location?.type || "") : true);
};

export const getRelationFavorites = (favorites: Favorite[], types?: Array<string>) => {

	const hasMatch = (relation: Relation) => {

		let match = false;

		if (types) {
			types.forEach(t => {
				const rt = relationTypesAndBooleans.find(({ key }) => t === key);
				const capitalizeFirstLetter = (str: string) => str[0].toUpperCase() + str.slice(1);
				const field = `is${rt?.field ? capitalizeFirstLetter(rt.field) : ""}` as keyof Relation;

				if (rt && relation[field]) {
					match = true;
				}
			});
		}

		return match;
	};

	return favorites
		.filter((it) => it.entityType === FavoriteType.Relation)
		.filter((it) => (types && it.relation) ? hasMatch(it.relation) : true);
};

export const capitalize = (value: string) => `${value[0].toUpperCase()}${value.slice(1)}`;
